"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _TextEffect2 = _interopRequireDefault(require("./TextEffect"));

var _Color = _interopRequireDefault(require("../../../models/Color"));

var _creative = require("../../../constants/creative");

var _text = require("../../../constants/text");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_DROP_SHADOW_VALUES = _text.DEFAULT_TEXT_EFFECTS_OBJECTS[_text.TEXT_EFFECTS.DROP_SHADOW];

var DropShadowTextEffect = /*#__PURE__*/function (_TextEffect) {
  (0, _inherits2["default"])(DropShadowTextEffect, _TextEffect);

  var _super = _createSuper(DropShadowTextEffect);

  function DropShadowTextEffect() {
    (0, _classCallCheck2["default"])(this, DropShadowTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DropShadowTextEffect, null, [{
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      var textRenderProperties = contentFrameData.textRenderProperties;
      var shadowColor = textRenderProperties.textEffect.get('color') || DEFAULT_DROP_SHADOW_VALUES.color;
      var shadowOffsetX = textRenderProperties.textEffect.get('xOffset');
      var shadowOffsetY = textRenderProperties.textEffect.get('yOffset');
      var opacity = textRenderProperties.textEffect.get('opacity') / 100;

      var rgbaColor = _Color["default"].getColorFromHexColor(shadowColor, opacity);

      finalContext.shadowColor = rgbaColor.toString();
      finalContext.shadowOffsetX = shadowOffsetX;
      finalContext.shadowOffsetY = shadowOffsetY;
      finalContext.shadowBlur = textRenderProperties.textEffect.get('blur') / 5; // divide blur by 5 to match svg text effect

      this.drawTextLines(finalContext, contentFrameData);
      finalContext.shadowColor = _creative.TRANSPARENT_FILL_COLOR; // remove shadow !
    }
  }]);
  return DropShadowTextEffect;
}(_TextEffect2["default"]);

exports["default"] = DropShadowTextEffect;